export class EncodingUtil {
  static hexToAscii(hexString) {
    let ret = '';
    for (let i = 0; i < hexString.length; i += 2) {
      ret = ret + String.fromCharCode(parseInt(hexString.substr(i, 2), 16));
    }
    return ret;
  }

  static hexToBase64(hexString) {
    try {
      return btoa(hexString.match(/\w{2}/g).map((a) => String.fromCharCode(parseInt(a, 16))).join(''));
    } catch (e) {
      return null;
    }
  }
}
